import { TPictures } from 'core/API/picturesApi';

export const KPIS = {
    nbProducts: { title: 'Number of products' },
    nbPendingReview: { title: 'Images pending review' },
    nbUploaded: { title: 'Images uploaded' },
};

export type TSortTypes = { title: string; filterKey: keyof TPictures | 'nbPictures' };

export const sortTypes: Record<string, TSortTypes> = {
    date: { title: 'Last updated', filterKey: 'updated_at' },
    creation: { title: 'Last created', filterKey: 'created_at' },
    nbImages: { title: 'Number of photos', filterKey: 'nbPictures' },
};

export const filterBy: (keyof TPictures)[] = ['ean', 'product_name', 'upc'];
